<section class="py-12 sm:py-16 lg:py-20 bg-bg-base overflow-hidden">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
      <div class="order-2 lg:order-1" style="opacity: 1; transform: none">
        <div
          class="inline-flex items-center gap-2 bg-gradient-to-r from-primary to-primary-deep text-text-primary px-4 py-2 rounded-full text-sm mb-6"
          style="opacity: 1; transform: none">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-smartphone w-4 h-4" aria-hidden="true">
            <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect>
            <path d="M12 18h.01"></path>
          </svg><span>{{ 'home.downloadApp.badge' | translate }}</span>
        </div>
        <h2 class="text-3xl sm:text-4xl md:text-5xl text-text-primary mb-4 leading-tight"
          style="opacity: 1; transform: none">
          {{ 'home.downloadApp.title' | translate }}
        </h2>
        <p class="text-base sm:text-lg text-text-secondary mb-6 sm:mb-8" style="opacity: 1; transform: none">
          {{ 'home.downloadApp.subtitle' | translate }}
        </p>
        <div class="space-y-4 mb-8" style="opacity: 1; transform: none">
          <div class="flex items-center gap-3">
            <div
              class="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span class="text-text-secondary">{{
              'home.downloadApp.features.smartSearch' | translate
              }}</span>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span class="text-text-secondary">{{
              'home.downloadApp.features.notifications' | translate
              }}</span>
          </div>
          <div class="flex items-center gap-3">
            <div
              class="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <span class="text-text-secondary">{{
              'home.downloadApp.features.directContact' | translate
              }}</span>
          </div>
        </div>
        <div class="flex items-start sm:items-center gap-4 sm:gap-6 mb-8 flex-col sm:flex-row"
          style="opacity: 1; transform: none">
          <div class="flex items-center gap-2">
            <div class="flex">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-5 h-5 text-warning fill-warning" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-5 h-5 text-warning fill-warning" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-5 h-5 text-warning fill-warning" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-5 h-5 text-warning fill-warning" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-star w-5 h-5 text-warning fill-warning" aria-hidden="true">
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
              </svg>
            </div>
            <div>
              <div class="text-text-primary font-semibold">4.8</div>
              <div class="text-xs text-text-muted">
                {{ 'home.downloadApp.rating.reviews' | translate }}
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <div
              class="w-10 h-10 bg-info/20 rounded-full flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-download w-5 h-5 text-info" aria-hidden="true">
                <path d="M12 15V3"></path>
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <path d="m7 10 5 5 5-5"></path>
              </svg>
            </div>
            <div>
              <div class="text-text-primary font-semibold">
                {{ 'home.downloadApp.downloads.count' | translate }}
              </div>
              <div class="text-xs text-text-muted">
                {{ 'home.downloadApp.downloads.subtitle' | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap items-stretch sm:items-center gap-3 sm:gap-4" style="opacity: 1; transform: none">
          <a href="#"
            class="group w-full sm:w-auto flex items-center gap-3 btn btn-secondary px-5 sm:px-6 py-3.5 hover:scale-105"><svg
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-apple w-8 h-8 text-text-primary" aria-hidden="true">
              <path d="M12 6.528V3a1 1 0 0 1 1-1h0"></path>
              <path
                d="M18.237 21A15 15 0 0 0 22 11a6 6 0 0 0-10-4.472A6 6 0 0 0 2 11a15.1 15.1 0 0 0 3.763 10 3 3 0 0 0 3.648.648 5.5 5.5 0 0 1 5.178 0A3 3 0 0 0 18.237 21">
              </path>
            </svg>
            <div class="text-left">
              <div class="text-xs opacity-90">
                {{ 'home.downloadApp.stores.appStore.text' | translate }}
              </div>
              <div class="font-semibold text-lg text-text-primary">
                {{ 'home.downloadApp.stores.appStore.name' | translate }}
              </div>
            </div>
          </a><a href="#"
            class="group w-full sm:w-auto flex items-center gap-3 btn btn-secondary px-5 sm:px-6 py-3.5 hover:scale-105"><svg
              class="w-8 h-8" viewBox="0 0 24 24" fill="none">
              <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z"
                fill="#00D9FF"></path>
              <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="#FFCE00"></path>
              <path d="M3.84 2.15L6.05 2.66L14.54 11.15L6.05 2.66L3.84 2.15Z" fill="#FF3A44"></path>
              <path d="M16.81 8.88L14.54 11.15L6.05 2.66L16.81 8.88Z" fill="#00F076"></path>
              <path d="M20.16 11.37C20.5 11.55 20.5 12.45 20.16 12.63L16.81 14.46L14.54 12.19L16.81 9.92L20.16 11.37Z"
                fill="#FFCE00"></path>
            </svg>
            <div class="text-left">
              <div class="text-xs opacity-90">
                {{ 'home.downloadApp.stores.googlePlay.text' | translate }}
              </div>
              <div class="font-semibold text-lg text-text-primary">
                {{ 'home.downloadApp.stores.googlePlay.name' | translate }}
              </div>
            </div>
          </a>
          <div
            class="w-full sm:w-auto flex items-center gap-3 surface-card px-4 py-3.5 hover:border-primary transition-all">
            <div class="w-16 h-16 bg-surface-elevated rounded-lg flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-qr-code w-12 h-12 text-text-primary" aria-hidden="true">
                <rect width="5" height="5" x="3" y="3" rx="1"></rect>
                <rect width="5" height="5" x="16" y="3" rx="1"></rect>
                <rect width="5" height="5" x="3" y="16" rx="1"></rect>
                <path d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
                <path d="M21 21v.01"></path>
                <path d="M12 7v3a2 2 0 0 1-2 2H7"></path>
                <path d="M3 12h.01"></path>
                <path d="M12 3h.01"></path>
                <path d="M12 16v.01"></path>
                <path d="M16 12h1"></path>
                <path d="M21 12v.01"></path>
                <path d="M12 21v-1"></path>
              </svg>
            </div>
            <div class="text-left">
              <div class="text-sm text-text-primary font-medium">
                {{ 'home.downloadApp.stores.qrCode.title' | translate }}
              </div>
              <div class="text-xs text-text-muted">
                {{ 'home.downloadApp.stores.qrCode.subtitle' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-1 lg:order-2 relative" style="opacity: 1; transform: none">
        <div class="absolute inset-0 bg-gradient-to-br from-bg-base/20 to-transparent rounded-full blur-3xl"></div>
        <div
          class="absolute -top-10 -right-10 w-72 h-72 bg-gradient-to-br from-primary/20 to-primary-deep/20 rounded-full blur-3xl">
        </div>
        <div class="relative z-10">
          <div class="relative mx-auto max-w-[280px] sm:max-w-sm" style="transform: none">
            <div
              class="absolute inset-0 bg-gradient-to-br from-bg-base/30 to-bg-base/10 rounded-[3.5rem] blur-3xl transform translate-y-10 scale-95">
            </div>
            <div
              class="relative bg-gradient-to-br from-bg-secondary via-surface to-bg-secondary rounded-[2.5rem] sm:rounded-[3.5rem] p-2 sm:p-2.5 shadow-2xl border border-border-subtle">
              <div class="absolute -left-1 top-32 w-1 h-16 bg-gradient-to-b from-border-strong to-border-subtle rounded-l-full">
              </div>
              <div class="absolute -left-1 top-52 w-1 h-12 bg-gradient-to-b from-border-strong to-border-subtle rounded-l-full">
              </div>
              <div class="absolute -right-1 top-40 w-1 h-20 bg-gradient-to-b from-border-strong to-border-subtle rounded-r-full">
              </div>
              <div class="bg-bg-base rounded-[2.2rem] sm:rounded-[3.2rem] overflow-hidden relative border border-border">
                <div
                  class="absolute top-4 left-1/2 -translate-x-1/2 w-32 h-9 bg-bg-base rounded-full z-20 shadow-2xl border border-border-subtle">
                </div>
                <div class="absolute top-0 left-0 right-0 h-12 z-10 px-8 pt-2 flex justify-between items-start">
                  <!-- <div class="text-text-primary text-xs font-semibold">9:41</div> -->
                </div>
                <div class="relative w-full h-[500px] sm:h-[640px]">
                  <img
                    src="https://images.unsplash.com/photo-1736232249544-0b9008cf623f?crop=entropy&amp;cs=tinysrgb&amp;fit=max&amp;fm=jpg&amp;ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZWFsJTIwZXN0YXRlJTIwbW9iaWxlJTIwYXBwfGVufDF8fHx8MTc2NTg5MTIwM3ww&amp;ixlib=rb-4.1.0&amp;q=80&amp;w=1080"
                    alt="HomiGo App" class="w-full h-full object-cover opacity-80 mix-blend-luminosity" />
                  <div
                    class="absolute inset-0 bg-gradient-to-t from-bg-base/90 via-bg-base/50 to-transparent flex flex-col justify-end p-5 sm:p-8">
                    <div class="text-text-primary space-y-4">
                      <div class="flex items-center gap-3 mb-4">
                        <div
                          class="w-16 h-16 rounded-[1.2rem] flex items-center justify-center shadow-2xl border border-border-strong overflow-hidden bg-white/5 backdrop-blur-md">
                          <img src="logo.png" alt="HomiGo Logo" class="w-full h-full object-contain p-2" />
                        </div>
                        <div>
                          <div class="text-xl font-bold">HomiGo</div>
                          <div class="text-sm text-text-secondary">Easy and fast way to find your home</div>
                        </div>
                      </div>
                      <div class="space-y-2">
                        <div class="flex items-center gap-2 text-sm">
                          <div class="w-6 h-6 bg-success/20 rounded-full flex items-center justify-center">
                            <svg class="w-3 h-3 text-success" fill="currentColor" viewBox="0 0 20 20">
                              <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd"></path>
                            </svg>
                          </div>
                          <span class="text-text-secondary">{{
                            'home.downloadApp.appFeatures.smartSearch' | translate
                            }}</span>
                        </div>
                        <div class="flex items-center gap-2 text-sm">
                          <div class="w-6 h-6 bg-info/20 rounded-full flex items-center justify-center">
                            <svg class="w-3 h-3 text-info" fill="currentColor" viewBox="0 0 20 20">
                              <path fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                clip-rule="evenodd"></path>
                            </svg>
                          </div>
                          <span class="text-text-secondary">{{
                            'home.downloadApp.appFeatures.properties' | translate
                            }}</span>
                        </div>
                      </div>
                      <div
                        class="btn btn-primary w-full shadow-lg">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-download w-4 h-4" aria-hidden="true">
                          <path d="M12 15V3"></path>
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <path d="m7 10 5 5 5-5"></path>
                        </svg><span>{{ 'home.downloadApp.appFeatures.downloadNow' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-bg-base/50 to-transparent"></div>
              </div>
              <div class="absolute bottom-2 left-1/2 -translate-x-1/2 w-36 h-1.5 bg-border-strong rounded-full"></div>
            </div>
            <div
              class="hidden sm:block absolute -top-8 -left-8 surface-card p-4"
              style="opacity: 1; transform: none">
              <div class="flex items-center gap-3">
                <div
                  class="w-12 h-12 bg-success/20 rounded-xl flex items-center justify-center shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-users w-6 h-6 text-success" aria-hidden="true">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <path d="M16 3.128a4 4 0 0 1 0 7.744"></path>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                  </svg>
                </div>
                <div>
                  <div class="text-lg font-bold text-text-primary">50K+</div>
                  <div class="text-xs text-text-muted">Active Users</div>
                </div>
              </div>
            </div>
            <div
              class="hidden sm:block absolute -bottom-8 -right-8 surface-card p-4"
              style="opacity: 1; transform: none">
              <div class="flex items-center gap-3">
                <div
                  class="w-12 h-12 bg-warning/20 rounded-xl flex items-center justify-center shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-star w-6 h-6 text-warning fill-warning" aria-hidden="true">
                    <path
                      d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                    </path>
                  </svg>
                </div>
                <div>
                  <div class="text-lg font-bold text-text-primary">4.8/5</div>
                  <div class="text-xs text-text-muted">Excellent Rating</div>
                </div>
              </div>
            </div>
            <div
              class="hidden lg:block absolute top-1/2 -left-12 surface-card p-3"
              style="opacity: 1; transform: none">
              <div class="text-center">
                <div
                  class="w-10 h-10 bg-info/20 rounded-lg flex items-center justify-center mx-auto mb-2 shadow-lg">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-download w-5 h-5 text-info" aria-hidden="true">
                    <path d="M12 15V3"></path>
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10 5 5 5-5"></path>
                  </svg>
                </div>
                <div class="text-sm font-bold text-text-primary">50K+</div>
                <div class="text-xs text-text-muted">Downloads</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>